// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_GetServicosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/getServicos
 *
 * Returns list of available servicos for orcamentos.
 */
import type { Orcamentos_GetServicosRow } from './Orcamentos_GetServicosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_GetServicosResponseDados = Orcamentos_GetServicosRow[];

export type Orcamentos_GetServicosResponse = ApiResponse<Orcamentos_GetServicosResponseDados>;

registerResponseContract('Orcamentos_GetServicosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servico_id:           { type: 'number',  required: true },
      servico_nome:         { type: 'string',  required: true },
      servico_valor_padrao: { type: 'number',  required: true },
      servicoscategoria_id: { type: 'string',  required: true },
      servicocategoria_id:  { type: 'string',  required: false },
    },
  },
})
